import { FC } from 'react';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import cardFaqButtonClick from '@hh.ru/analytics-js-events/build/career_platform/faq/card_faq_button_click';
import cardFaqElementShown from '@hh.ru/analytics-js-events/build/career_platform/faq/card_faq_element_shown';
import { Text, TitleProps, useBreakpoint } from '@hh.ru/magritte-ui';

import { FAQDto } from 'src/types/common';

import FAQContainer from 'src/components/FAQ/components/FAQContainer';
import FAQItem from 'src/components/FAQ/components/FAQItem';

import styles from './styles.less';

interface Props {
    title: string;
    titleAlignment?: TitleProps['alignment'];
    data: FAQDto;
}

const FAQ: FC<Props> = ({ data, title, titleAlignment = 'left' }) => {
    const { isMobile } = useBreakpoint();

    return (
        <FAQContainer title={title} titleAlignment={titleAlignment}>
            {data.map((item, index) => (
                <ElementShownAnchor key={index} fn={(ref) => cardFaqElementShown(ref, { title: item.title })}>
                    <FAQItem title={item.title} onClick={() => cardFaqButtonClick({ title: item.title })}>
                        <Text
                            key={index}
                            typography={isMobile ? 'paragraph-3-regular' : 'paragraph-2-regular'}
                            Element="p"
                        >
                            <span className={styles.preLine}>{item.text}</span>
                        </Text>
                    </FAQItem>
                </ElementShownAnchor>
            ))}
        </FAQContainer>
    );
};

export default FAQ;
